import {AlertType} from "../../interfaces/IAlert"; import {AlertType} from
"../../interfaces/IAlert";
<template>
  <v-container class="login-container" fill-height fluid>
    <div class="login-background">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1903 556"
      >
        <path
          class="svg-banner-shape"
          d="M753.1,434.2c110.6,63.7,277.7,70.6,373.4,15.4L1905,0v555.9H0V0.2L753.1,434.2z"
        ></path>
      </svg>
    </div>
    <v-row align="center" justify="center" style="z-index: 10">
      <v-col cols="11" sm="7" md="5" lg="4" xl="3">
        <div class="logo text-center mb-12 font-weight-medium">
          <img :src="'/admin/assets/img/logos/homelogo.png'" />
        </div>
        <v-card>
          <v-card-text>
            <p v-if="loading" class="mb-0 grey--text">Cargando...</p>
            <p v-else-if="valid" class="mb-0 grey--text">
              Cuenta verificada con éxito
            </p>
            <p v-else class="mb-0 grey--text">El link es inválido</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { vueData } from '../../VueData';
  import AuthService from '../../api/services/auth.service';
  import { AlertType } from '../../interfaces/IAlert';
  import { IUser } from '../../interfaces/IUser';

  @Component
  export default class VerifyEmail extends Vue {
    @Prop() user: IUser;
    authService = new AuthService();
    loading: boolean = true;
    valid: boolean = false;

    async created() {
      if (this.token) {
        try {
          await this.authService.verifyEmail(this.token as string);
          this.valid = true;
          vueData.addAlert('Cuenta verificada con éxito', AlertType.Success);
          if (vueData.user) {
            vueData.user.emailVerified = true;
            this.$router.replace('/');
          } else this.$router.replace('/login');
        } catch (e) {
          this.valid = false;
          vueData.addAlert('El link es inválido', AlertType.Error);
          this.$router.replace('/login');
        } finally {
          this.loading = false;
        }
      } else {
        this.valid = false;
        this.loading = false;
      }
    }

    get token() {
      return this.$route.query.token;
    }
  }
</script>
